import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';

import remoteAccessIcon from '../../../../../assets/images/vpn_remote_64.png';
import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.remoteAccess;
const pageId = pageSchema.pageId;

function BaseRemoteAccess({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const manageInSmp  = pageData[pageSchema.manageInSmp];
    const mode         = pageData[pageSchema.mode];
    const allowTraffic = pageData[pageSchema.allowTraffic];
    const logTraffic   = pageData[pageSchema.logTraffic];

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);


    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLAN.RA.RA_VPN')} managedInSmp={manageInSmp}>
                <RowLayout>
                    <img alt="" src={remoteAccessIcon} />
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>

                <EmptyRow />

                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                {/* Allow traffic */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={allowTraffic}
                    onChange={e => setPageValue(pageSchema.allowTraffic, e.target.checked)}
                    label={t('SMP.PLAN.RA.LINE1')}
                />
                {/* Log traffic */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={logTraffic}
                    onChange={e => setPageValue(pageSchema.logTraffic, e.target.checked)}
                    label={t('SMP.PLAN.RA.LINE2')}
                />
                
                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.RA.LINE3')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseRemoteAccess;